import { Result } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text } from 'components/mvp-typography';
import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import { getPatientLinkUrl } from 'navigation/router/route-switch/route-switch-patient/utils/patient-route-helpers';
import { PatientRoutes } from 'routes';

export function PatientHomeAssessmentUnblocked(props: {
  patientInfo: PatientInfoState;
}) {
  return (
    <>
      <div
        style={{
          background: 'white',
          padding: '1.2rem',
          borderRadius: 5,
          maxWidth: 650,
          width: '100%',
          color: 'black',
          fontWeight: 'bold'
        }}
      >
        <Result status={'success'}></Result>
        <Text>
          You have 72 hours after starting this test, to complete it, before the
          link expires.
        </Text>
        <br></br>
        <br></br>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <BaseButton
            href={getPatientLinkUrl(
              PatientRoutes.AssessmentStart,
              props.patientInfo.patient.id
            )}
          >
            Start your test
          </BaseButton>
        </div>
      </div>
    </>
  );
}
